import { useEffect, useRef, useState, type ReactNode } from "react";

interface FadeInSectionProps {
    children: ReactNode;
    className?: string;
}

export default function FadeInSection({
    children,
    className = "",
}: FadeInSectionProps) {
    const [isVisible, setVisible] = useState(false);
    const domRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setVisible(true);
                    if (domRef.current) {
                        observer.unobserve(domRef.current);
                    }
                }
            },
            {
                root: null,
                rootMargin: "0px",
                threshold: 0.15,
            },
        );

        const currentRef = domRef.current;
        if (currentRef) observer.observe(currentRef);

        return () => {
            if (currentRef) observer.unobserve(currentRef);
        };
    }, []);

    return (
        <div
            className={`${className} transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}
            ref={domRef}>
            {children}
        </div>
    );
}
